
import styled from 'styled-components';

export default function Hobby(props) {
  const { title, imagePath, description, text } = props;

  return (
    <HobbyContainer>
      <HobbyTitle>{title}</HobbyTitle>
      <Center>
        {imagePath && <HobbyImage src={imagePath} alt={description} />}
      </Center>
      <HobbyText>{text}</HobbyText>
    </HobbyContainer>
  )
}

const Center = styled.div`
  display: flex;
  justify-content: center;
`

const HobbyContainer = styled.div`

`;

const HobbyTitle = styled.h3`
  margin: 20px;
`;

const HobbyText = styled.p`
`;

const HobbyImage = styled.img`
  transition: all 0.2s;
  width: 40vw;
  height: auto;
  &:hover{
    transform: scale(1.4);
  }
  @media screen and (max-width: 600px){
  width: 100vw
}
`